import { useQuery } from "@tanstack/react-query";
import { Check, LogOut, ShieldCheck } from "lucide-react";
import { apiRequest } from "@/lib/api";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/Button";

function useHealthProbe() {
  return useQuery({
    queryKey: ["health"],
    staleTime: 30_000,
    retry: false,
    queryFn: async () => apiRequest<{ status: string }>("/health"),
  });
}

export function Header() {
  const auth = useAuth();
  const healthProbe = useHealthProbe();

  const phone = auth.status === "authenticated" ? auth.user.phone : null;

  const healthLabel = healthProbe.isPending
    ? "…"
    : healthProbe.isSuccess
      ? "API up"
      : "API down";
  const healthTone = healthProbe.isPending
    ? "bg-slate-100 text-slate-600"
    : healthProbe.isSuccess
      ? "bg-emerald-100 text-emerald-700"
      : "bg-red-100 text-red-700";

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white">
      <div className="flex items-center gap-3 px-4 h-14">
        <div className="flex items-center gap-2 min-w-0">
          <div className="h-7 w-7 rounded-md bg-brand-600 flex items-center justify-center">
            <Check className="h-4 w-4 text-white" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-slate-900 leading-tight truncate">
              PahCertificar
            </p>
            <p className="text-[11px] text-slate-500 leading-tight">Admin</p>
          </div>
        </div>

        <div className="ml-auto flex items-center gap-2">
          <span
            className={cn(
              "inline-flex items-center gap-1 px-2 py-1 rounded-full text-[11px] font-medium",
              healthTone
            )}
          >
            {healthLabel}
          </span>

          {phone && (
            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-1 text-[11px] font-medium text-emerald-700">
              <ShieldCheck className="h-3.5 w-3.5" />
              <span className="font-mono">{phone}</span>
            </span>
          )}

          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => auth.signOut()}
            title="Cerrar sesión"
          >
            <LogOut className="h-3.5 w-3.5" />
            Salir
          </Button>
        </div>
      </div>
    </header>
  );
}
